<template>
  <div class="apply-form__section apply-form__documents">
    <ValidationObserver>
      <v-row>
        <template v-for="(type, key) in extraTypes">
          <v-col
            v-if="type.Value"
            :key="key"
            cols="12"
            md="6"
            class="d-flex align-self-start"
          >
            <ValidationProvider
              v-slot="validationData"
              :name="`extra_file_${key}`"
              mode="eager"
              slim
              :rules="'required|fileUploaded'"
            >
              <file-input
                :label="type.TextValue + '*'"
                :accept="allowedFileTypes"
                :upload-endpoint="'application-file'"
                :download-endpoint="'application-file'"
                :name="`extra_file_${key}`"
                :validation-data="validationData"
                :file-prefix="formId"
                v-model="extraTypeModels[key]"
                multiple
              ></file-input>
            </ValidationProvider>
          </v-col>
        </template>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
import fileInput from '../../file-input.vue';
import applicationFileType from '@/enum/application-file-type';
import validationModeEnums from '@/enum/field-validation-mode.js';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  components: {
    fileInput,
    ValidationProvider,
    ValidationObserver
  },

  props: {
    extraTypes: {
      type: Object,
      required: false,
      default: () => ({})
    },
    formId: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    allowedFileTypes: {
      type: String,
      required: true
    }
  },

  computed: {
    applicationFileType() {
      return applicationFileType.ApplicationFileTypes;
    },

    fieldValidationMode() {
      return validationModeEnums.FieldValidationModes;
    },
    extraTypeModels: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
